module.exports = __webpack_public_path__ + "img/pr-21.41e89fc2.png";